<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <b-container>
    <b-row>
      <!-- <b-col
        v-if="currentBreakPoint !== 'xs'"
        class="d-flex justify-content-center align-items-center order-sm-2 order-md-1"
        sm="12"
        md="4"
      >
        <b-img
          width="400px"
          :src="require('@/assets/images/pages/coming-soon.svg')"
        />
      </b-col> -->
      <b-col
        sm="12"
        md="12"
        class="order-sm-1 order-md-2"
      >
        <b-card>
          <b-card-title>
            {{ $t('editUser') }}
          </b-card-title>
          <validation-observer ref="formValidation">
            <b-form @submit.prevent="validateForm()">
              <b-row>
                <b-col
                  sm="12"
                  lg="4"
                >
                  <b-form-group label="Nombre">
                    <validation-provider
                      #default="{ errors }"
                      name="Nombre"
                      rules="required"
                    >
                      <b-form-input v-model="user.name" autocomplete="off" type="text" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  lg="4"
                >
                  <b-form-group label="Email">
                    <validation-provider
                      #default="{ errors }"
                      name="Email"
                      rules="required|email"
                    >
                      <b-form-input v-model="user.email" type="email" />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small
                        v-if="user.pending_email"
                        class="text-warning d-block"
                      >
                        Hay un cambio pendiente de confirmación para {{ user.pending_email }}.
                      </small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  lg="4"
                >
                  <b-form-group label="WhatsApp">
                    <validation-provider
                      #default="{ errors }"
                      name="WhatsApp"
                      rules="required|digits:10"
                    >
                      <b-form-input
                        v-model="user.phone"
                        autocomplete="off"
                        type="tel"
                        inputmode="numeric"
                        maxlength="10"
                        @input="sanitizePhone"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="user.role_name === 'customer' || adminCustomerMode"
                  sm="12"
                  lg="4"
                >
                  <b-form-group :label="$t('companyName')">
                    <b-form-input
                      v-model.trim="user.company_name"
                      autocomplete="off"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mb-1">
                <b-col sm="12">
                  <h4>{{ $t('userLogo') }}</h4>
                  <div class="d-flex">
                    <base-cropper
                      :index="'0'"
                      :model="user"
                      @cropped-image="user.logo = $event"
                    />
                    <span class="text-muted ml-1">{{
                      $t('resolutionInfo')
                    }}</span>
                  </div>
                </b-col>
              </b-row>
              <b-row
                v-if="companyLogoValidRoles.includes(user.role_name)"
                class="mb-1"
              >
                <b-col sm="12">
                  <h4>{{ $t('companyLogo') }}</h4>
                  <div class="d-flex">
                    <base-cropper
                      :index="'1'"
                      :model="user.company_information"
                      :boundary="{ width: 300, height: 300 }"
                      :viewport="{ width: 206, height: 40, type: 'square' }"
                      @cropped-image="user.company_information.logo = $event"
                    />
                    <span class="text-muted ml-1">{{
                      $t('resolutionCompanyLogoInfo')
                    }}</span>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col
                  sm="12"
                  class="d-flex flex-wrap"
                >
                  <div class="mr-1 mb-1 mb-md-0">
                    <h4>{{ $t('primaryColor') }}</h4>
                    <div class="color-picker-selector">
                      <color-picker
                        theme="dark"
                        :color="user.primary_color"
                        :sucker-hide="true"
                        :colors-default="[]"
                        @changeColor="changePrimaryColor"
                      />
                    </div>
                  </div>
                  <div>
                    <h4>{{ $t('secondaryColor') }}</h4>
                    <div class="color-picker-selector">
                      <color-picker
                        theme="dark"
                        :color="user.secondary_color"
                        :sucker-hide="true"
                        :colors-default="[]"
                        @changeColor="changeSecondaryColor"
                      />
                    </div>
                  </div>
                </b-col>
              </b-row>
              <div class="text-right">
                <b-button
                  variant="primary"
                  type="submit"
                >
                  {{ $t('save') }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
        <account-deletion-card v-if="currentUser && currentUser.role_name === 'customer'" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, digits, email } from '@validations'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useAppCustomizer from '@core/layouts/components/app-customizer/useAppCustomizer'
import colorPicker from '@caohenghu/vue-colorpicker'
import BaseCropper from '@/components/BaseCropper.vue'
import AccountDeletionCard from '@/components/account/AccountDeletionCard.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BaseCropper,
    colorPicker,
    AccountDeletionCard,
  },
  data() {
    return {
      required,
      digits,
      email,
      user: {
        name: '',
        email: '',
        phone: '',
        pending_email: null,
      },
    }
  },
  setup() {
    const { navbarColors, navbarBackgroundColor } = useAppCustomizer()
    return {
      navbarColors,
      navbarBackgroundColor,
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('app', ['currentBreakPoint', 'isSmallScreen']),
    companyLogoValidRoles() {
      return ['supplier_admin', 'customer']
    },
  },
  created() {
    this.user = this.normalizeUserForm(this.currentUser)
  },
  methods: {
    ...mapMutations('auth', {
      setCurrentUser: 'setCurrentUser',
    }),
    ...mapActions('users', ['editUser']),

    changePrimaryColor(color) {
      document.documentElement.style.setProperty('--primary-custom', color.hex)
      this.user.primary_color = color.hex
    },
    changeSecondaryColor(color) {
      document.documentElement.style.setProperty(
        '--secondary-custom',
        color.hex,
      )
      this.user.secondary_color = color.hex
    },
    sanitizePhone(value) {
      this.user.phone = String(value || '').replace(/\D/g, '').slice(0, 10)
    },
    normalizeUserForm(user) {
      const normalizedUser = JSON.parse(JSON.stringify(user || {}))
      if (!normalizedUser.phone && normalizedUser.customer?.phone) {
        normalizedUser.phone = normalizedUser.customer.phone
      }
      if (!normalizedUser.company_name && normalizedUser.customer?.company_name) {
        normalizedUser.company_name = normalizedUser.customer.company_name
      }
      normalizedUser.phone = String(normalizedUser.phone || '').replace(/\D/g, '').slice(0, 10)
      normalizedUser.pending_email = normalizedUser.pending_email || null
      normalizedUser.company_name = String(normalizedUser.company_name || '').trim()
      if (typeof normalizedUser.company_information === 'string') {
        normalizedUser.company_information = { logo: null }
      }
      return normalizedUser
    },

    validateForm() {
      this.$refs.formValidation.validate().then(success => {
        if (success) {
          const payload = {
            ...this.user,
            phone: String(this.user.phone || '').replace(/\D/g, ''),
            company_name: String(this.user.company_name || '').trim(),
          }
          if (this.user.company_information?.logo?.data) {
            payload.company_information_attributes = this.user.company_information
          }
          this.editUser(payload).then(response => {
            this.setCurrentUser(response)
            localStorage.setItem('userData', JSON.stringify(response))
            this.user = this.normalizeUserForm(response)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.pending_email ? 'Revisa tu nuevo correo para confirmar el cambio' : this.$t('settingsUpdated'),
                icon: 'UserIcon',
                variant: 'success',
              },
            })
            if (response.role_name === 'customer') {
              this.$router.push({
                name: 'projects',
                params: {
                  customerId: response.scoped_roles[0]?.role_resource_id,
                },
              })
            }
          }).catch(error => {
            const messages = error.response?.data?.messages || error.messages || ['No fue posible actualizar tu perfil']
            this.$toast({
              component: ToastificationContent,
              props: {
                title: Array.isArray(messages) ? messages.join(', ') : messages,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.color-picker-selector {
  ::v-deep .color-type {
    display: none;
  }
  ::v-deep .history {
    display: none;
  }
  ::v-deep .color-show {
    display: none;
    height: 0px !important;
  }
  ::v-deep .color-alpha {
    display: none;
    height: 0px !important;
  }
}
</style>
